import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, CircularProgress, Divider, Grid, LinearProgress, linearProgressClasses, Link, Switch, Typography } from "@mui/material";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import CommonFeatureIcon from "../../common/components/CommonFeatureIcon";
import { Check, Close } from "@mui/icons-material";
import styled from "@emotion/styled";
import { getAcademicAnalytics, getProjectAnalytics } from "../../api/studentPerformanceApi";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { ExamTypes, ServiceOffer, TimeBlocks, TopUpServices } from "../../common/const";
import CommonDialog from "../../common/components/CommonDialog";
import LineChart from "../Dcp Tutoring/LineChart";
import BarChart from "../Dcp Tutoring/BarChart";
import TaskCarousel from "./TaskCarousel";
import { getAllAssignSubject } from "../../api/subjectApi";
import moment from "moment";

const Options = {
    Project: 'Project Mentoring',
    Skill: 'Skills Coaching'
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 6,
    borderRadius: 5,
    marginTop: 8,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: '#10AE2D',
        ...theme.applyStyles('dark', {
            backgroundColor: '#10AE2D',
        }),
    },
}));

const ProjectMentoring = () => {
    const { user } = useSelector((state) => state.auth);
    const [testType, setTestType] = useState(Options.Project);
    const [addSession, setAddSession] = useState(false);
    const [successOpen, setSuccess] = useState(false);
    const [selectedService, setSelectedServices] = useState(TopUpServices[0].label);
    const [timing, selectTiming] = useState(TimeBlocks[0].value);
    const [examType, setExamType] = useState(ExamTypes.PROJECTMENTORING);
    const dispatch = useDispatch();
    const [chartType, setChartType] = useState(true);
    const [data, setData] = useState(null);
    const [subService, setSubService] = useState(null);
    const [assignSkill, setAssignSkill] = useState([]);

    const getProjectData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getProjectAnalytics();
            setData(response.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    const getAssignedSubject = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getAllAssignSubject(ServiceOffer.skillCoach, user?.student_id);
            setSubService(response?.data?.[0]?.student_subject_id);
            setAssignSkill(response?.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    };


    useEffect(() => {
        if (testType === Options.Project) {
            getProjectData();
        } else if (testType === Options.Skill) {
            getAssignedSubject();
        }
    }, [testType]);

    const getExamData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getAcademicAnalytics(ServiceOffer.skillCoach, '', subService);
            setData(response.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (subService) {
            getExamData();
        }
    }, [subService]);

    return (
        <Fragment>
            <CommonDialog
                open={successOpen}
                size="xs"
                title={
                    <Fragment>
                        <Close
                            sx={{
                                color: theme.palette.background.dark, fontSize: 20,
                                float: 'right',
                                cursor: 'pointer'
                            }}
                            onClick={() => {
                                setSuccess(false);
                                setAddSession(true);
                            }}
                        />
                    </Fragment>
                }
                content={(
                    <center>
                        <img
                            src='/Images/success.png'
                            alt='Check Circle'
                            style={{ width: '70px', height: '70px', marginTop: 20 }}
                        />
                        <Typography sx={{ fontWeight: 600, fontSize: '22px', mt: 0.5 }}>
                            Hours Added Successfully
                        </Typography>
                        <Typography variant="body2" color="text.secondary" paragraph mt={0.3}>
                            You have added {TimeBlocks.find((a) => a.value === timing)?.time}s to your project Mentoring Balance
                        </Typography>
                        <CommonCard
                            paddingBottom="0px"
                            borderRadius={2}
                            background="#FAFAFA"
                            content={
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Box display="flex" justifyContent="space-between">
                                            <Typography fontWeight={600}>Available Sessions</Typography>
                                            <Typography fontWeight={600} color="#10AE2D">+ {TimeBlocks.find((a) => a.value === timing)?.time}s</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <CommonCard
                                            paddingBottom="0px"
                                            padding="10px 10px 5px 10px"
                                            borderRadius={2}
                                            marginTop="0px"
                                            content={
                                                <Box textAlign="left">
                                                    <Typography fontWeight={600}>02</Typography>
                                                    <Typography color="background.dark">Previous</Typography>
                                                </Box>
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <CommonCard
                                            paddingBottom="0px"
                                            padding="10px 10px 5px 10px"
                                            borderRadius={2}
                                            marginTop="0px"
                                            content={
                                                <Box textAlign="left">
                                                    <Typography fontWeight={600}>{Number(TimeBlocks.find((a) => a.value === timing)?.time?.split(' ')?.[0]) + 2} Hours</Typography>
                                                    <Typography color="background.dark">Updated</Typography>
                                                </Box>
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            }
                        />
                    </center>
                )}
                actionButtons={(
                    <CommonButton
                        label="Return To Dashboard"
                        size="small"
                        marginBottom="10px"
                        handleClick={() => {
                            setSuccess(false);
                            setAddSession(false);
                            setSelectedServices(TopUpServices[0].label);
                            selectTiming(TimeBlocks[0].value);
                        }}
                    />
                )}
            />
            <CommonDialog
                open={addSession}
                size="md"
                title={
                    <Fragment>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: 600, fontSize: 18 }}>Top up Your Session</Typography>
                            <Close
                                sx={{
                                    color: theme.palette.background.dark, fontSize: 20,
                                    float: 'right',
                                    cursor: 'pointer'
                                }}
                                onClick={() => {
                                    setAddSession(false);
                                    setSelectedServices(TopUpServices[0].label);
                                    selectTiming(TimeBlocks[0].value);
                                }}
                            />
                        </Box>
                        <Box width="80%" mb={1}>
                            <Typography sx={{ fontSize: 12 }} color={theme.palette.background.dark}>Purchase additional hours for your plan</Typography>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Grid container spacing={1} mt={0.1}>
                        <Grid item md={12}>
                            <Typography fontWeight={600}>Which service do you need more time for?</Typography>
                        </Grid>
                        {(examType ? TopUpServices.filter((i) => i.examType === examType || i?.examType?.includes(examType)) : TopUpServices).map((a, index) => (
                            <Grid item xs={examType ? 12 : 2.4} key={index} onClick={() => setSelectedServices(a.label)}>
                                <CommonCard
                                    paddingBottom="0px"
                                    borderRadius={2}
                                    marginTop="0px"
                                    height="100px"
                                    border={!examType && `3px solid ${selectedService === a.label ? a.color === 'white' ? theme.palette.primary.main : a.color : '#000001A'}`}
                                    background={a.background}
                                    content={
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: '100%',           // Take full height of parent
                                                width: '100%',            // Take full width of parent
                                                flexDirection: 'column',
                                                textAlign: 'center'
                                            }}
                                        >
                                            <img src={a.image} alt="icon" />
                                            <Typography mt={0.5} fontSize={14} color={a.color}>
                                                {a.label}
                                            </Typography>
                                        </Box>
                                    }
                                />
                            </Grid>
                        ))}
                        <Grid item md={12}>
                            <Typography fontWeight={600}>Choose a Time Block</Typography>
                        </Grid>
                        {TimeBlocks.map((a, index) => (
                            <Grid item xs={3} key={index} onClick={() => selectTiming(a.value)}>
                                {a.popular ? (
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            height: 'fit-content'
                                        }}
                                    >
                                        <CommonCard
                                            paddingBottom="0px"
                                            borderRadius={2}
                                            marginTop="0px"
                                            background={timing === a.value ? theme.palette.secondary.main : '#FFEECF'}
                                            content={
                                                <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center">
                                                    <Typography fontSize={15} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : 'black'}>{a.time}</Typography>
                                                    <Typography fontSize={17} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : theme.palette.primary.main}>{a.value}</Typography>
                                                    <Typography fontSize={14} textAlign="center" color={timing === a.value ? 'white' : theme.palette.background.dark}>{a.label}</Typography>
                                                </Box>
                                            }
                                        />
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: '-9px',
                                                right: '65px',
                                                backgroundColor: '#D08700',
                                                color: 'white',
                                                padding: '2px 10px',
                                                borderRadius: '12px',
                                                fontSize: '10px',
                                                zIndex: 10
                                            }}
                                        >
                                            Most Popular
                                        </Box>
                                    </Box>
                                ) : (
                                    <CommonCard
                                        paddingBottom="0px"
                                        borderRadius={2}
                                        marginTop="0px"
                                        background={timing === a.value ? theme.palette.secondary.main : '#FFEECF'}
                                        content={
                                            <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center">
                                                <Typography fontSize={15} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : 'black'}>{a.time}</Typography>
                                                <Typography fontSize={17} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : theme.palette.primary.main}>{a.value}</Typography>
                                                <Typography fontSize={14} textAlign="center" color={timing === a.value ? 'white' : theme.palette.background.dark}>{a.label}</Typography>
                                            </Box>
                                        }
                                    />
                                )}
                            </Grid>
                        ))}
                    </Grid>
                }
                actionButtons={(
                    <Box display="flex" justifyContent="space-between" width="100%" mt={2}>
                        <Box>
                            <Typography fontWeight={600}>{selectedService}</Typography>
                            <Box display="flex" gap={1}>
                                <Typography color={theme.palette.background.dark}>{TimeBlocks.find((a) => a.value === timing)?.time} - </Typography>
                                <Typography color={theme.palette.secondary.main} fontWeight={600}>{timing}</Typography>
                            </Box>
                        </Box>
                        <CommonButton
                            label="Proceed To Payment"
                            size="small"
                            background={theme.palette.secondary.main}
                            color={theme.palette.background.main}
                            fontWeight={700}
                            marginBottom="10px"
                            width="180px"
                            handleClick={() => {
                                setSuccess(true);
                            }}
                        />
                    </Box>
                )}
            />
            <CommonCard
                borderRadius={2}
                headerContent={
                    <Fragment>
                        <Grid container spacing={2} mb={1} p={2}>
                            <Grid item md={6}>
                                <Box
                                >
                                    <Box display="flex" gap={1}>
                                        <CommonButton
                                            label={Options.Project}
                                            width="170px"
                                            fontWeight={600}
                                            color={testType === Options.Project ? theme.palette.secondary.main : theme.palette.background.dark}
                                            background={testType === Options.Project ? theme.palette.primary.main : '#FAFAFA'}
                                            handleClick={() => {
                                                setTestType(Options.Project);
                                                setExamType(ExamTypes.PROJECTMENTORING);
                                            }}
                                            marginBottom="0px"
                                        />
                                        <CommonButton
                                            label={Options.Skill}
                                            width="160px"
                                            fontWeight={600}
                                            color={testType === Options.Skill ? theme.palette.secondary.main : theme.palette.background.dark}
                                            background={testType === Options.Skill ? theme.palette.primary.main : '#FAFAFA'}
                                            handleClick={() => {
                                                setTestType(Options.Skill);
                                                setExamType(ExamTypes.SKILLS);
                                            }}
                                            marginBottom="0px"
                                        />
                                    </Box>
                                    <Box mt={2}>
                                        <Typography fontWeight={600}>{testType === Options.Project ? 'My Project Insights' : testType}</Typography>
                                        <Typography fontSize={14} color={theme.palette.background.dark}>Quick insights from {testType === Options.Project ? 'projects' : 'skills'}</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            {testType === Options.Project ? (
                                <Grid item md={6}>
                                    <CommonCard
                                        borderRadius={2}
                                        paddingBottom="0px"
                                        marginTop="0px"
                                        background={theme.palette.secondary.main}
                                        content={
                                            <Fragment>
                                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                                    <Box>
                                                        <Typography fontSize={15} color="white">{testType === Options.Project ? 'Next Milestone Due Date' : 'Next Exam Date'}</Typography>
                                                        <Typography fontSize={20} fontWeight={600} color={theme.palette.primary.main}>{data?.current_milestone?.due_date ? moment(data?.current_milestone?.due_date)?.format('MMM DD') : ''}</Typography>
                                                        <Typography fontSize={13} color="white">This is the right time to take {testType.toLowerCase()} service <Link sx={{ color: "white", textDecoration: 'none', borderBottom: '1px solid white' }} onClick={() => setAddSession(true)}>Add Session</Link></Typography>
                                                    </Box>
                                                    <CommonFeatureIcon icon={<img
                                                        src='/Images/Calendar.png'
                                                        style={{
                                                            width: 20,
                                                        }}
                                                        alt=''
                                                    />}
                                                        background="white"
                                                        height="45px"
                                                        width="45px"
                                                    />
                                                </Box>
                                            </Fragment>
                                        }
                                    />
                                </Grid>
                            ) : (
                                <Grid item md={6}>
                                    <CommonCard
                                        borderRadius={2}
                                        paddingBottom="0px"
                                        marginTop="0px"
                                        background={theme.palette.secondary.main}
                                        content={
                                            <Fragment>
                                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                                    <Box>
                                                        <Typography fontSize={15} color="white">Upcoming Test/Quiz/Assignment</Typography>
                                                        <Typography fontSize={18} fontWeight={600} color='#3FDFDF'>Next Test - {data?.next_exam?.find((a) => a.type === 'TEST')?.exam_date ? moment(data?.next_exam?.find((a) => a.type === 'TEST')?.exam_date)?.format('MMM DD') : ''}</Typography>
                                                        <Typography fontSize={18} fontWeight={600} color='#F815FC'>Next Quiz - {data?.next_exam?.find((a) => a.type === 'QUIZ')?.exam_date ? moment(data?.next_exam?.find((a) => a.type === 'QUIZ')?.exam_date)?.format('MMM DD') : ''}</Typography>
                                                        <Typography fontSize={18} fontWeight={600} color={theme.palette.primary.main}>Next Assignment - {data?.next_exam?.find((a) => a.type === 'ASSIGNMENT')?.exam_date ? moment(data?.next_exam?.find((a) => a.type === 'ASSIGNMENT')?.exam_date)?.format('MMM DD') : ''}</Typography>
                                                        <Typography fontSize={14} color="white">This is the right time to take Skill Coaching service <Link sx={{ color: "white", textDecoration: 'none', borderBottom: '1px solid white' }} onClick={() => setAddSession(true)}>Add Session</Link></Typography>
                                                    </Box>
                                                    <CommonFeatureIcon icon={<img
                                                        src='/Images/Calendar.png'
                                                        style={{
                                                            width: 20,
                                                        }}
                                                        alt=''
                                                    />}
                                                        background="white"
                                                        height="45px"
                                                        width="45px"
                                                    />
                                                </Box>
                                            </Fragment>
                                        }
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {testType === Options.Project ? (
                            <Box display="flex" gap={1} alignItems="center" p={2}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '50%',
                                    background: '#10AE2D',
                                    width: 70,
                                    height: 70,
                                    position: 'relative'
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '50%',
                                        border: '2px solid white',
                                        width: 30,
                                        height: 30
                                    }}>
                                        <Check sx={{ color: 'white', fontSize: 14 }} />
                                    </Box>
                                </Box>
                                <Box width="90%">
                                    <Typography color="#10AE2D" fontSize={16} fontWeight={600}>Your Project Is {data?.percent_complete}% Completed</Typography>
                                    <Typography color="background.dark" fontSize={13}>{data?.percent_complete}% of your project is completed. The remaining steps will shape the final experience.</Typography>
                                    <BorderLinearProgress variant="determinate" value={data?.percent_complete} />
                                </Box>
                            </Box>
                        ) : <Grid container spacing={1}>
                            {assignSkill.length > 0 && assignSkill.map((a) => (
                                <Grid item sm={12} md={2}>
                                    <CommonButton
                                        label={a?.subject?.name}
                                        width="150px"
                                        fontWeight={600}
                                        border={subService !== a.student_subject_id ? `1px solid #0000001A` : 'none'}
                                        color={subService === a.student_subject_id ? theme.palette.secondary.main : 'gray'}
                                        background={subService === a.student_subject_id ? theme.palette.primary.main : '#FAFAFA'}
                                        handleClick={() => setSubService(a.student_subject_id)}
                                        marginBottom="0px"
                                    />
                                </Grid>
                            ))}
                        </Grid>}
                        {testType === Options.Project && (
                            <Divider />
                        )}
                    </Fragment>
                }
                content={
                    <Fragment>
                        {testType === Options.Project ? (
                            <Grid container spacing={2}>
                                <Grid item md={4} sm={12}>
                                    <CommonCard
                                        paddingBottom="0px"
                                        borderRadius={2}
                                        marginTop="0px"
                                        background="#FEF9C2"
                                        content={
                                            <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                                                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                                    <CircularProgress
                                                        variant="determinate"
                                                        value={100}
                                                        size={50}
                                                        thickness={6}
                                                        sx={{
                                                            color: '#e0e0e0', // Light gray for remaining portion
                                                            position: 'absolute',
                                                            '& .MuiCircularProgress-circle': {
                                                                strokeLinecap: 'round',
                                                            },
                                                        }}
                                                    />
                                                    <CircularProgress
                                                        variant="determinate"
                                                        value={data?.current_milestone?.completed ? ((data?.current_milestone?.completed / data?.current_milestone?.total_task) * 100) : 0}
                                                        size={50}
                                                        thickness={6}
                                                        sx={{
                                                            color: theme.palette.primary.main, // Your progress color
                                                            '& .MuiCircularProgress-circle': {
                                                                strokeLinecap: 'round',
                                                            },
                                                        }}
                                                    />
                                                    <Box
                                                        sx={{
                                                            top: 0,
                                                            left: 0,
                                                            bottom: 0,
                                                            right: 0,
                                                            position: 'absolute',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        <Typography
                                                            fontSize={12}
                                                            component="div"
                                                            fontWeight={700}
                                                            color="text.primary"
                                                        >
                                                            {`${data?.current_milestone?.completed ? ((data?.current_milestone?.completed / data?.current_milestone?.total_task) * 100) : 0}%`}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                <Typography fontWeight={600}>{data?.current_milestone?.name ? data?.current_milestone?.name : ''}</Typography>
                                            </Box>
                                        }
                                    />
                                </Grid>
                                <Grid item md={4} sm={12}>
                                    <CommonCard
                                        paddingBottom="0px"
                                        borderRadius={2}
                                        marginTop="0px"
                                        background="#DCFCE7"
                                        content={
                                            <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                                                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                                    <CircularProgress
                                                        variant="determinate"
                                                        value={100}
                                                        size={50}
                                                        thickness={6}
                                                        sx={{
                                                            color: '#e0e0e0', // Light gray for remaining portion
                                                            position: 'absolute',
                                                            '& .MuiCircularProgress-circle': {
                                                                strokeLinecap: 'round',
                                                            },
                                                        }}
                                                    />
                                                    <CircularProgress
                                                        variant="determinate"
                                                        value={data?.task_completion?.completed ? ((data?.task_completion?.completed / data?.task_completion?.total) * 100) : 0}
                                                        size={50}
                                                        thickness={6}
                                                        sx={{
                                                            color: theme.palette.secondary.default,// Full green
                                                            '& .MuiCircularProgress-circle': {
                                                                strokeLinecap: 'round',
                                                            },
                                                        }}
                                                    />
                                                    <Box
                                                        sx={{
                                                            top: 0,
                                                            left: 0,
                                                            bottom: 0,
                                                            right: 0,
                                                            position: 'absolute',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        <Typography
                                                            fontSize={12}
                                                            component="div"
                                                            fontWeight={700}
                                                            color="text.primary"
                                                        >
                                                            {`${data?.task_completion?.completed ? ((data?.task_completion?.completed / data?.task_completion?.total) * 100) : 0}%`}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                <Typography fontWeight={600}>Task Completion</Typography>
                                            </Box>
                                        }
                                    />
                                </Grid>
                                <Grid item md={4} sm={12}>
                                    <CommonCard
                                        paddingBottom="0px"
                                        borderRadius={2}
                                        marginTop="0px"
                                        background="#FEE2E2"
                                        content={
                                            <TaskCarousel
                                                tasks={data?.next_tasks}
                                            />
                                        }
                                    />
                                </Grid>
                            </Grid>
                        ) : (
                            <Fragment>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography fontWeight={600}>Progress</Typography>
                                    <Box display="flex" gap={2}>
                                        <Box
                                            display="flex"
                                            gap={1}
                                            alignItems="center"
                                            sx={{
                                                background: '#FAFAFA',
                                                paddingLeft: 1,
                                                paddingRight: 1,
                                                borderRadius: 1
                                            }}
                                        >
                                            <Typography fontSize={13}>Line Chart</Typography>
                                            <Switch
                                                size="Medium"
                                                checked={chartType}
                                                onChange={(e) => setChartType(e.target.checked)}
                                            />
                                            <Typography fontSize={13}>Bar Chart</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                {data?.history?.map((a) => a.month) && (
                                    chartType === true ? (
                                        <BarChart
                                            colors={[theme.palette.primary.main, '#F815FC', '#3FDFDF']}
                                            chartSeries={[
                                                {
                                                    name: 'Assignments',
                                                    data: data?.history?.map((a) => a.scores?.assignment_avg)
                                                },
                                                {
                                                    name: 'Quizzes',
                                                    data: data?.history?.map((a) => a.scores?.quiz_avg)
                                                },
                                                {
                                                    name: 'Tests',
                                                    data: data?.history?.map((a) => a.scores?.test_avg)
                                                }
                                            ]}
                                            categories={data?.history?.map((a) => a.month)}
                                            percentage
                                            width="20%"
                                        />
                                    ) : (
                                        <LineChart
                                            colors={[theme.palette.primary.main, '#F815FC', '#3FDFDF']}
                                            chartSeries={[
                                                {
                                                    name: 'Assignments',
                                                    data: data?.history?.map((a) => a.scores?.assignment_avg)
                                                },
                                                {
                                                    name: 'Quizzes',
                                                    data: data?.history?.map((a) => a.scores?.quiz_avg)
                                                },
                                                {
                                                    name: 'Tests',
                                                    data: data?.history?.map((a) => a.scores?.test_avg)
                                                }
                                            ]}
                                            categories={data?.history?.map((a) => a.month)}
                                        />
                                    )
                                )}
                            </Fragment>
                        )}
                    </Fragment>
                }
                paddingBottom="0px"
                padding="13px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default ProjectMentoring;